export const NAME_REGEXP = "^[\\p{L}\\s\\.\\-\\']*$";
export const MOBILE_PHONE_REGEXP = '^(70|20|30|31|50)\\s\\d{3}\\s\\d{4}$';
export const ZIPCODE_REGEXP = '[0-9]{4}';